import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { documentsApi } from '@api/documents/documentsApi';
import { IBtlDocument } from '@api/documents/types';

export const useBtlDocuments = (applicationId: string): UseQueryResult<IBtlDocument[]> =>
  useQuery(['btl-documents', applicationId], () => (applicationId ? documentsApi.getBtlDocuments(applicationId) : []), {
    enabled: !!applicationId,
  });
